import { BaseController } from '@maia/feature-utils';
import { BrokerDto, BrokerService, TeamDto } from '@maia/shared';

export class BrokerController extends BaseController {
  constructor(private brokerService: BrokerService) {
    super();
  }

  async getAll() {
    const response = await this.brokerService.getAll('brokers');
    return response.map((broker) => new BrokerDto(broker));
  }

  async findMany(search: Record<string, unknown>) {
    const response = await this.brokerService.findMany('brokers', search);
    return response;
  }

  async find(guid: string) {
    const response = await this.brokerService.find(guid);
    return new BrokerDto(response);
  }

  async getSelf() {
    const response = await this.brokerService.getSelf();
    return new BrokerDto(response);
  }

  async getTeams() {
    const response = await this.brokerService.getTeams();
    return response.map((team) => new TeamDto(team));
  }
}
